import Vue from "vue";
import store from "../store";
import VueRouter from "vue-router";
import { Session } from "@/utils/storage";
import { PrevLoading } from "@/utils/loading.js";
// import generatepage from "./generatepage"; // 内容管理
// 引入版本更新提醒
import autoUpdate from "../autoUpdate";
// 解决 `element ui` 导航栏重复点菜单报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

// 安装 VueRouter 插件
Vue.use(VueRouter);

// 移动端检测工具函数
const DeviceDetector = {
  // 通过User Agent检测移动设备
  isMobileDevice() {
    const userAgent = navigator.userAgent.toLowerCase();
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
  },
  // 综合检测方法
  detectDevice() {
    const isMobileUA = this.isMobileDevice();
    // const isTabletUA = this.isTabletDevice();
    const width = window.innerWidth;

    // 屏幕小于1200的，统一处理为移动端
    if (isMobileUA && width < 1200) return "mobile";
    // if ((isTabletUA || width >= 768) && width < 1024) return "tablet";
    return "desktop";
  },
};
var deviceType = DeviceDetector.detectDevice();

// 加载路由
const createRouter = () =>
  new VueRouter({
    mode: "history",
    routes: [
      { path: "/login", name: "login", component: () => import("@/views/login"), meta: { title: "登录" } },
      { path: "/404", name: "notFound", component: () => import("@/views/error/404.vue"), meta: { title: "找不到此页面" } },
      { path: "/401", name: "noPower", component: () => import("@/views/error/401.vue"), meta: { title: "登录过期" } },
      { path: "/scan", name: "scan", component: () => import("@/views/scan/index.vue"), meta: { title: "手机扫码" } },
      { path: "/refresh", name: "refresh", component: () => import("@/common/refresh.vue"), meta: { title: "刷新" } },
    ],
  });
const router = createRouter(); // 创建路由

// tagsViewList 数据，路由全部缓存
// setCacheTagsViewRoutes(dynamicRoutes[0].children);
// 多级嵌套数组处理成一维数组
export function formatFlatteningRoutes(arr) {
  if (arr.length <= 0) return false;
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].children) {
      arr = arr.slice(0, i + 1).concat(arr[i].children, arr.slice(i + 1));
    }
  }
  return arr;
}

// 处理 tagsViewList 数据，路由全部缓存
export function formatTwoStageRoutes(arr) {
  if (arr.length <= 0) return false;
  const newArr = [];
  arr.forEach(item => {
    newArr.push({ ...item });
  });
  return newArr;
}
// 缓存多级嵌套数组处理后的一维数组
export function setCacheTagsViewRoutes(arr) {
  let rolesRoutes = setFilterMenuFun(arr);
  // 添加到 vuex setTagsViewRoutes 中
  store.dispatch("tagsViewRoutes/setTagsViewRoutes", formatTwoStageRoutes(formatFlatteningRoutes(rolesRoutes)));
}
// 递归过滤路由
export function setFilterMenuFun(routes) {
  const menu = [];
  routes.forEach(route => {
    const item = { ...route };
    if (item.children) {
      item.children = setFilterMenuFun(item.children);
    }
    menu.push(item);
  });
  return menu;
}
// 重置路由
export function resetRouter() {
  router.matcher = createRouter().matcher;
}
// 添加动态路由，`{ path: '*', redirect: '/404' }` 防止页面刷新，静态路由丢失问题
export function adminUser(router, to, next) {
  // 读取用户信息，获取对应权限进行判断---有地区的只展示研讨会管理菜单
  let roleRouter = JSON.parse(localStorage.getItem("region"));
  // 先重置路由
  resetRouter();
  // 所有路由
  const dynamicRoutes = roleRouter
    ? [
        {
          path: "/",
          component: () => import("@/components/index"),
          redirect: "/seminarmanage",
          children: [
            {
              name: "seminarmanage",
              path: "/seminarmanage",
              meta: { title: "研讨会管理", menu: "seminarmanage", isMenu: true, language: [1], icon: "el-icon-school" },
              component: () => import("@/views/seminarmanage/index.vue"),
            },
            {
              name: "seminarmanageDetail",
              path: "/seminarmanageDetail",
              meta: { title: "报名详情", menu: "seminarmanage", isMenu: false },
              component: () => import("@/views/seminarmanage/detail.vue"),
            },
            {
              name: "manual",
              path: "/manual",
              meta: { title: "操作手册", menu: "manual", isMenu: false, language: [1] },
              component: () => import("@/components/manual.vue"),
            },
          ],
        },
      ]
    : [
        {
          path: "/",
          component: () => import("@/components/index"),
          redirect: "/classificationManagement",
          children: [
            // categoryType 栏目类型 1：文章，2：单页，3：频道，4：公共页
            {
              path: "/classificationManagement",
              name: "classificationManagement",
              component: () => import("@/views/classificationManagement/index.vue"),
              meta: {
                title: "内容管理",
                menu: "classificationManagement",
                isMenu: true,
                categoryType: "",
                language: [1, 2, 3],
                icon: "el-icon-tickets",
              },
            },
            {
              name: "addPage",
              path: "/addPage",
              meta: { title: "新增页面", menu: "classificationManagement", isMenu: false },
              component: () => import("@/views/components/pageDetail.vue"),
            },
            {
              name: "addPage6",
              path: "/addPage6",
              meta: { title: "新增页面", menu: "classificationManagement", isMenu: false },
              component: () => import("@/views/components/pageDetail6.vue"),
            },{
              name: "fixtrue",
              path: "/fixtrue",
              meta: { title: "新增页面", menu: "classificationManagement", isMenu: false },
              component: () => import("@/views/components/fixtrueDetail.vue"),
            },
            {
              name: "pageDetail",
              path: "/pageDetail",
              meta: { title: "页面详情", menu: "classificationManagement", isMenu: false },
              // 文章详情（修改）与新增文章使用同一套表单，保证字段/上传方式一致
              component: () => import("@/views/components/pageDetail.vue"),
            },
            {
              name: "pageDetail6",
              path: "/pageDetail6",
              meta: { title: "页面块详情", menu: "classificationManagement", isMenu: false },
              component: () => import("@/views/components/pageDetail6.vue"),
            },{
              name: "fixtrueDetail",
              path: "/fixtrueDetail",
              meta: { title: "页面块详情", menu: "classificationManagement", isMenu: false },
              component: () => import("@/views/components/fixtrueDetail.vue"),
            },
            {
              name: "contact1Detail",
              path: "/contact1Detail",
              meta: { title: "联系我们详情", menu: "classificationManagement", isMenu: false },
              component: () => import("@/views/components/contact1Detail.vue"),
            },
            {
              path: "/publicAdministration",
              name: "publicAdministration",
              component: () => import("@/views/classificationManagement/index.vue"),
              meta: {
                title: "公共页管理",
                menu: "publicAdministration",
                isMenu: true,
                categoryType: 4,
                language: [1, 2, 3],
                icon: "el-icon-document-copy",
              },
            },
            {
              name: "addPage4",
              path: "/addPage4",
              meta: { title: "新增页面", menu: "publicAdministration", isMenu: false },
              component: () => import("@/views/components/pageDetail4.vue"),
            },
            {
              name: "pageDetail4",
              path: "/pageDetail4",
              meta: { title: "页面详情", menu: "publicAdministration", isMenu: false },
              component: () => import("@/views/components/pageDetail4.vue"),
            },
            {
              name: "addPage5",
              path: "/addPage5",
              meta: { title: "新增页面", menu: "channelManagement", isMenu: false },
              component: () => import("@/views/components/pageDetail.vue"),
            },
            {
              name: "pageDetail5",
              path: "/pageDetail5",
              meta: { title: "页面详情", menu: "channelManagement", isMenu: false },
              component: () => import("@/views/components/pageDetail.vue"),
            },
            {
              path: "/categoryManagement",
              name: "categoryManagement",
              component: () => import("@/views/categoryManagement/index.vue"),
              meta: { title: "SEO管理", menu: "categoryManagement", isMenu: true, categoryType: "", language: [1, 2, 3], icon: "el-icon-notebook-2" },
            },
            {
              path: "/publishAll",
              name: "publishAll",
              component: () => import("@/views/publishAll/index.vue"),
              meta: { title: "整站生成", menu: "publishAll", isMenu: true, categoryType: "", language: [1, 2, 3], icon: "el-icon-set-up" },
            },
            {
              path: "/visitStats",
              name: "visitStats",
              component: () => import("@/views/visitStats/index.vue"),
              meta: {
                title: "访问统计",
                menu: "visitStats",
                isMenu: true,
                language: [1, 2, 3],
                icon: "el-icon-data-line",
              },
            },
            {
              path: "/templateManage",
              name: "templateManage",
              component: () => import("@/views/templateManage/index.vue"),
              // 暂时隐藏「模板管理」菜单：把 isMenu 改回 true 即可重新显示（路由与页面保留，可直接用 /templateManage 访问）
              meta: {
                title: "模板管理",
                menu: "templateManage",
                isMenu: false,
                language: [1, 2, 3],
                icon: "el-icon-document",
              },
            },
            {
              name: "templateEdit",
              path: "/templateEdit",
              meta: { title: "模板编辑", menu: "templateManage", isMenu: false },
              component: () => import("@/views/templateManage/edit.vue"),
            },
            {
              path: "/bannermanageDetail",
              name: "bannermanageDetail",
              component: () => import("@/views/bannermanage/detail.vue"),
              meta: { title: "广告详情", menu: "bannermanage", isMenu: false },
            },
			{
			  name: "officialMsgs",
			  path: "/officialMsgs",
			  meta: { title: "在线留言", menu: "officialMsgs", isMenu: true, language: [1], icon: "el-icon-time" },
			  component: () => import("@/views/officialMsgs/index.vue"),
			},
            {
              name: "officialLogs",
              path: "/officialLogs",
              meta: { title: "日志查询", menu: "officialLogs", isMenu: true, language: [1], icon: "el-icon-time" },
              component: () => import("@/views/officialLogs/index.vue"),
            },
            {
              name: "manual",
              path: "/manual",
              meta: { title: "操作手册", menu: "manual", isMenu: false, language: [1] },
              component: () => import("@/components/manual.vue"),
            },
            {
              name: "userManage",
              path: "/userManage",
              meta: { title: "用户管理", menu: "userManage", isMenu: true, language: [1], icon: "el-icon-user" },
              component: () => import("@/views/userManage/index.vue"),
            },
          ],
        },
      ];

  // 根据权限设置路由
  store.dispatch("routesList/setRoutesList", setFilterMenuFun(dynamicRoutes[0].children));
  [
    {
      path: "/",
      redirect: deviceType === "mobile" ? "/scan" : roleRouter ? "/seminarmanage" : "/classificationManagement",
    },
    ...dynamicRoutes,
    { path: "*", redirect: "/404" },
  ].forEach(route => {
    router.addRoute({ ...route });
  });
  // 缓存所有路由
  setCacheTagsViewRoutes(JSON.parse(JSON.stringify(dynamicRoutes[0].children)));
  next({ ...to, replace: true });
}
// 加载 loading
// PrevLoading.start();
// 路由加载前
router.beforeEach((to, from, next) => {
  // 检查版本更新
  autoUpdate.start();
  let token = Session.get("token");
  if (to.path === "/login" && !token) {
    next();
  } else {
    // 没有token，且不包含这些页面，且为菜单页面
    if (!token && !["/401", "/404"].includes(to.path) && to.meta.isMenu) {
      // token过期，登录后返回到原页面
      next("/login?redirect=" + to.path);
      Session.clear();
    } else {
      if (Object.keys(store.state.routesList.routesList).length <= 0) {
        adminUser(router, to, next); // 添加动态路由
      } else {
        next();
      }
    }
  }
  // if (Object.keys(store.state.routesList.routesList).length <= 0) {
  //   // 读取用户信息，获取对应权限进行判断--暂无权限判断，默认全部添加
  //   store.dispatch("routesList/setRoutesList", setFilterMenuFun(dynamicRoutes[0].children));
  // }
});
// 路由加载后
router.afterEach(() => {
  PrevLoading.done(); // loading
});

// 导出路由
export default router;
